export const NAME = 'name';
export const POSITION = 'positionId';
export const MANAGER = 'managerId';
export const DEPARTMENT = 'departmentId';
export const EMAIL = 'email';
export const PROFILE = 'profile';
export const PERMISSIONS = 'permissions';
export const COMPANY = 'companyId';
export const STUDIO = 'studioId';
export const IS_SYSTEM = 'isSystem';
export const IS_TEST = 'isTest';
export const IS_GROUP = 'isGroup';
export const IS_NEVER_LOCK = 'isNeverLock';
export const ROLE = 'roleIds';
export const TEAM = 'teamId';
export const SUPER_TEAM = 'superTeamId';
